import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastComponent } from './toast.component';
import { ToastModule as ToastModuleS } from '@syncfusion/ej2-angular-notifications';


@NgModule({
  declarations: [
    ToastComponent
  ],
  imports: [
    CommonModule,
    ToastModuleS,
  ],
  exports:[
    ToastComponent
  ]
})
export class ToastModule { }
